import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../app-constants";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: GenerativeAIServiceTick,
    title: "Initial Consultation & Strategy",
    description:
      "Meet your dedicated account representative to define your goals. We'll craft a custom SEM strategy, targeting high-value keywords aligned with your business objectives.",
    count: "01",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Comprehensive Keyword Research",
    description:
      "Using advanced tools, we identify high-performing keywords and filter out negatives. This ensures your budget focuses on driving meaningful traffic and conversions.",
    count: "02",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Ad Creation & Landing Page Optimization",
    description:
      "We design compelling ads and link them to optimized landing pages, aligning with user intent to guide visitors seamlessly through your conversion funnel.",
    count: "03",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Campaign Setup & Tracking Integration",
    description:
      "We precisely set up your SEM account and integrate tracking systems. This enables precise performance monitoring and ensures accurate conversion data.",
    count: "04",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Campaign Launch & Continuous Monitoring",
    description:
      "After setup, we launch and closely monitor your campaign, adjusting settings like location and device targeting for optimal performance and ad spend efficiency.",
    count: "05",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Regular Reporting & Performance Evaluation",
    description:
      "Receive detailed reports on key performance indicators (KPIs), including CTR and conversion costs. We analyze results to refine strategies for sustained SEM success.",
    count: "06",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Ongoing Optimization & Strategy Refinement",
    description:
      "Based on performance data, we continuously optimize your campaigns, tweaking bids, ads, and landing pages to improve ROI and outpace competitors.",
    count: "07",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Cost-Effective, Long-Term Growth",
    description:
      "Our transparent pricing structure ensures you know exactly where your budget goes. We focus on maximum ROI and long-term growth through effective SEM practices.",
    count: "08",
  },
];
const Workflow = () => {
  return (
    <div
      className="workflow p-100 nlp_process_flow search-engine-workflow"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Our Extensive Search Engine Marketing <span>Workflow</span>
            </h2>
            <p>
              We plan and execute performant paid marketing campaigns, targeting
              high-value keywords and user intent. Our detailed search engine
              marketing process is structured to curate an industry-specific,
              rewarding action plan that not only boosts search impressions with
              above-the-fold placement but also generates clicks and conversions
              with immersive UI/UX and compelling copywriting.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-3 mb-md-4">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
        <Row className="justify-content-center">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-3 mt-md-5 text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Get a Custom PPC Plan
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
